import { render, staticRenderFns } from "./HierarchyPersonList.vue?vue&type=template&id=230bc59b&scoped=true&"
import script from "./HierarchyPersonList.vue?vue&type=script&lang=js&"
export * from "./HierarchyPersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bc59b",
  null
  
)

export default component.exports